import type {SanityPage} from '@/schema/documents/page';
import type {MediaFragment} from '@/schema/primitives/media';

import type {LinkableDocumentTypes} from '../schema/primitives/link';

export const THEME_DARK = 'dark';
export const THEME_LIGHT = 'light';
export type Theme = typeof THEME_DARK | typeof THEME_LIGHT;

// Used to identify the form in the DOM, so it can be linked to
export const NEWSLETTER_FORM_ID = 'newsletter-form';

export type LinkableDocument = {
	_id: string;
	_type: LinkableDocumentTypes;
	title?: string;
	tagline?: string;
	media?: MediaFragment;
	slug?: {
		current?: string;
	};
	category?: {
		title?: string;
		slug?: {
			current?: string;
		};
	};
	heading?: SanityPage['heading'];
	meta?: SanityPage['meta'];
};
